const FORM_VALIDATION_MESSAGES = {
  INVALID_CREDENTIALS: 'Invalid email or password. Please try again.',
  ACCESS_DENIED:
    'Access Denied: You do not have permission to access the admin console. Your role does not grant administrative privileges.',
  SOMETHING_WENT_WRONG: 'Something went wrong. Please try again later.'
};

export { FORM_VALIDATION_MESSAGES };
